import type React from "react";

import {
  Menubar as ShadcnMenubar,
  MenubarPortal as ShadcnMenubarPortal,
  MenubarMenu as ShadcnMenubarMenu,
  MenubarTrigger as ShadcnMenubarTrigger,
  MenubarContent as ShadcnMenubarContent,
  MenubarGroup as ShadcnMenubarGroup,
  MenubarSeparator as ShadcnMenubarSeparator,
  MenubarLabel as ShadcnMenubarLabel,
  MenubarItem as ShadcnMenubarItem,
  MenubarShortcut as ShadcnMenubarShortcut,
  MenubarCheckboxItem as ShadcnMenubarCheckboxItem,
  MenubarRadioGroup as ShadcnMenubarRadioGroup,
  MenubarRadioItem as ShadcnMenubarRadioItem,
  MenubarSub as ShadcnMenubarSub,
  MenubarSubTrigger as ShadcnMenubarSubTrigger,
  MenubarSubContent as ShadcnMenubarSubContent,
} from "src/shadcn/components/menubar";

const Menubar = (props: React.ComponentProps<typeof ShadcnMenubar>) => (
  <ShadcnMenubar {...props} />
);

const MenubarPortal = (
  props: React.ComponentProps<typeof ShadcnMenubarPortal>
) => <ShadcnMenubarPortal {...props} />;

const MenubarMenu = (props: React.ComponentProps<typeof ShadcnMenubarMenu>) => (
  <ShadcnMenubarMenu {...props} />
);

const MenubarTrigger = (
  props: React.ComponentProps<typeof ShadcnMenubarTrigger>
) => <ShadcnMenubarTrigger {...props} />;

const MenubarContent = (
  props: React.ComponentProps<typeof ShadcnMenubarContent>
) => <ShadcnMenubarContent {...props} />;

const MenubarGroup = (
  props: React.ComponentProps<typeof ShadcnMenubarGroup>
) => <ShadcnMenubarGroup {...props} />;

const MenubarSeparator = (
  props: React.ComponentProps<typeof ShadcnMenubarSeparator>
) => <ShadcnMenubarSeparator {...props} />;

const MenubarLabel = (
  props: React.ComponentProps<typeof ShadcnMenubarLabel>
) => <ShadcnMenubarLabel {...props} />;

const MenubarItem = (props: React.ComponentProps<typeof ShadcnMenubarItem>) => (
  <ShadcnMenubarItem {...props} />
);

const MenubarShortcut = (
  props: React.ComponentProps<typeof ShadcnMenubarShortcut>
) => <ShadcnMenubarShortcut {...props} />;

const MenubarCheckboxItem = (
  props: React.ComponentProps<typeof ShadcnMenubarCheckboxItem>
) => <ShadcnMenubarCheckboxItem {...props} />;

const MenubarRadioGroup = (
  props: React.ComponentProps<typeof ShadcnMenubarRadioGroup>
) => <ShadcnMenubarRadioGroup {...props} />;

const MenubarRadioItem = (
  props: React.ComponentProps<typeof ShadcnMenubarRadioItem>
) => <ShadcnMenubarRadioItem {...props} />;

const MenubarSub = (props: React.ComponentProps<typeof ShadcnMenubarSub>) => (
  <ShadcnMenubarSub {...props} />
);

const MenubarSubTrigger = (
  props: React.ComponentProps<typeof ShadcnMenubarSubTrigger>
) => <ShadcnMenubarSubTrigger {...props} />;

const MenubarSubContent = (
  props: React.ComponentProps<typeof ShadcnMenubarSubContent>
) => <ShadcnMenubarSubContent {...props} />;

export {
  Menubar,
  MenubarPortal,
  MenubarMenu,
  MenubarTrigger,
  MenubarContent,
  MenubarGroup,
  MenubarSeparator,
  MenubarLabel,
  MenubarItem,
  MenubarShortcut,
  MenubarCheckboxItem,
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubTrigger,
  MenubarSubContent,
};
